import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualArrayString";

export default defineType({
  title: "Brochure Section",
  name: "cruiseBrochureSection",
  type: "object",
  fields: [
    {
      name: "title",
      title: "Title",
      type: "multilingualArrayString"
    },
    {
      name: "content",
      title: "Content",
      type: "multilingualArrayBlockContent"
    },
    {
      name: "brochureGroup",
      title: "Brochure",
      type: "reference",
      to: [{ type: "brochureGrouping" }]
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title) || ""
      };
    }
  }
});
